import React, { useRef, useContext } from "react";
import classes from "./BarMessage.css";
import { StoreContext } from "../../../store/store";
import { removeBarMessage } from "../../../store/actions/message";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BarMessage = (props) => {
    const timerRef = useRef(null);
    const { state, dispatch } = useContext(StoreContext);
    const { t } = useTranslation();

    if (!state.message) {
        return null;
    }
    if (timerRef.current) {
        clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => dispatch(removeBarMessage()), 5000);

    const errorClass = state.message.type === "Error" ? classes.error : "";
    const unibrowIsShown = props.showUnibrow ? classes.unibrowIsShown : "";
    const barClasses = `${classes.barMessage} ${errorClass} ${unibrowIsShown}`;

    const handleClick = () => {
        dispatch(removeBarMessage());
    };

    const getMessageContent = () => {
        if (state.message.link) {
            return (
                <Trans
                    t={t}
                    i18nKey={state.message.content}
                    components={{ lnk: <Link to={state.message.link} onClick={handleClick} /> }}
                />
            );
        } else {
            return state.message.content;
        }
    };

    return (
        <div className={barClasses}>
            <div className={classes.innerContainer}>{getMessageContent()}</div>
        </div>
    );
};

export default BarMessage;
